//used with createcookie function to match domain
function getDomain() {

    var path = window.location.host;
    if (path.substr(0, 3) == 'www') {
        var per = path.indexOf('.')
        per = per + 1;
        path = path.substr(per);
    }

    return path;
}

function readCookie(name) {

    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

let getCookie = readCookie;

function createCookie(name, value, days, expire_in_hours) {
    var expires = "";
    if (days) {
        //allows us to set cookie expirations based on hours rather than days
        if (typeof expire_in_hours !== 'undefined' && expire_in_hours == true) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 60 * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
        } else {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
        }
    } else {
        var expires = "";
    }
    
    document.cookie = name + "=" + value + expires + "; path=/; domain=." + getDomain() + "";
    //For local testing
    // document.cookie = name + "=" + value + expires +"domain=." + getDomain(); "; path=/;";
}

let setCookie = createCookie;

function eraseCookie(name) {

    createCookie(name, "", -1);
}

let deleteCookie = eraseCookie;

export { getDomain, readCookie, getCookie, createCookie, setCookie, eraseCookie, deleteCookie };